import React, { Component } from 'react'
import s from './style.scss'
import { Query } from "react-apollo";
import gql from "graphql-tag";
// import { Link } from 'react-router-dom'
import urls from '../../../configs/urls'

import Tabs from '../../../components/Tabs/'

import General from './tabs/general'


class UsersDetails extends Component {

  render() {

    if (!this.props.uuid) return null

    return <React.Fragment>

    <Tabs
      tabs={[{
        name: 'General',
        content: <General uuid={this.props.uuid} />
      }
      ]} />

    </React.Fragment>

  }
}

export default UsersDetails;



// WEBPACK FOOTER //
// ./src/containers/users/Details/index.js